module.exports = __webpack_public_path__ + "img/bj_xia_zi@2x.1e0a32cb.png";